import React from "react";
import { Link } from "react-router-dom";
import user from "../../../images/developer (1).webp";
import development from "../../../images/development.webp";
import host from "../../../images/hosting.webp";
import avatar from "../../../images/peep.svg";
import design from "../../../images/ux.webp";
function WhatIDo() {
  return (
    <div className="whatIDo_wrapper">
      <div className="top-area">
        <img src={avatar} alt="avatar" />
        <h1>
          My <span className="purple">services</span> at a glance
        </h1>
        <p>What I do</p>
      </div>

      <div className="card-area">
        <div className="card">
          <div className="card-top">
            <div className="image">
              <img src={design} alt="" />
            </div>
            <h4>UX & Website Design</h4>
          </div>
          <div className="card-body">
            <p>
              I design beautiful, functional and purposeful apps, webapps and
              websites. From Wireframes to MVP to Pixel-Perfect designs. Complex
              workflows simplified but also beauty of a brand brought out by the
              simplicity.
            </p>
          </div>
          <div className="card-link">
            <Link to="/service">Learn more &gt;&gt; </Link>
          </div>
        </div>

        <div className="card">
          <div className="card-top">
            <div className="image">
              <img src={development} alt="" />
            </div>
            <h4>Web Application Development</h4>
          </div>
          <div className="card-body">
            <p>
              I build software, web and mobile applications, APIs
              and more. my team is experienced with modern technologies and
              programming languages.My process is effective and lean.I
              utilize agile project.
            </p>
          </div>
          <div className="card-link">
            <Link to="/service">Learn more &gt;&gt; </Link>
          </div>
        </div>
        <div className="card">
          <div className="card-top">
            <div className="image">
              <img src={host} alt="" />
            </div>
            <h4>Cloud, Devops, Hosting</h4>
          </div>
          <div className="card-body">
            <p>
              I run your application on the Cloud or in a Swiss Data Center
              depending on your requirements. Scalable, high-performance and
              cost effective. Support fully automated deployments, local or
              test environments. Complex requirements
            </p>
          </div>
          <div className="card-link">
            <Link to="/service">Learn more &gt;&gt; </Link>
          </div>
        </div>
        <div className="card">
          <div className="card-top">
            <div className="image">
              <img src={user} alt="" />
            </div>
            <h4>Dedicated Developers</h4>
          </div>
          <div className="card-body">
            <p>
              I will provide you talented and experienced developers for
              manage your project. Frontend developers, backend developers,
              full-stack developers, UX designers or devops..
            </p>
          </div>
          <div className="card-link">
            <Link to="/service">Learn more &gt;&gt; </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WhatIDo;
